var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileNoPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "48px",
    viewBox: "0 0 36 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1544496,0 C24.0618806,6.49464578e-15 24.9323039,0.359733351 25.5749706,1.00036627 L34.9919495,10.3875446 C35.6372832,11.0308361 36,11.9045531 36,12.8157498 L36,45.7142857 C36,46.9766509 34.9766509,48 33.7142857,48 L2.28571429,48 C1.02334914,48 -1.17767249e-15,46.9766509 0,45.7142857 L0,2.28571429 C-1.54595143e-16,1.02334914 1.02334914,-1.10037491e-15 2.28571429,0 L23.1544496,0 Z M22.857,2.278 L2.85714286,2.27848101 C2.5731107,2.27848101 2.33747928,2.48570921 2.29319332,2.7572209 L2.28571429,2.84990958 L2.28571429,45.1500904 C2.28571429,45.4341226 2.49294249,45.669754 2.76445417,45.71404 L2.85714286,45.721519 L33.1428571,45.721519 C33.4268893,45.721519 33.6625207,45.5142908 33.7068067,45.2427791 L33.7142857,45.1500904 L33.714,13.101 L25.1428571,13.1012658 C23.880492,13.1012658 22.8571429,12.0779167 22.8571429,10.8155515 L22.857,2.278 Z M12,37 C12.5522847,37 13,37.4477153 13,38 C13,38.5522847 12.5522847,39 12,39 L6,39 C5.44771525,39 5,38.5522847 5,38 C5,37.4477153 5.44771525,37 6,37 L12,37 Z M30,31 C30.5522847,31 31,31.4477153 31,32 C31,32.5522847 30.5522847,33 30,33 L6,33 C5.44771525,33 5,32.5522847 5,32 C5,31.4477153 5.44771525,31 6,31 L30,31 Z M30,25 C30.5522847,25 31,25.4477153 31,26 C31,26.5522847 30.5522847,27 30,27 L6,27 C5.44771525,27 5,26.5522847 5,26 C5,25.4477153 5.44771525,25 6,25 L30,25 Z M30,19 C30.5522847,19 31,19.4477153 31,20 C31,20.5522847 30.5522847,21 30,21 L6,21 C5.44771525,21 5,20.5522847 5,20 C5,19.4477153 5.44771525,19 6,19 L30,19 Z M24.5714286,2.84810127 L24.5714286,10.2495479 C24.5714286,10.8386517 25.017154,11.3236506 25.5897588,11.3856989 L25.7142857,11.3924051 L33.1428571,11.3924051 L24.5714286,2.84810127 Z",
    id: "Combined-Shape-Copy-58",
    fill: "#424C55"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNoPreview);
export default __webpack_public_path__ + "static/media/fileNoPreview.fe965304401a5db625b57728ec0adea6.svg";
export { ForwardRef as ReactComponent };